interface SectionHeaderProps {
  title: string;
  subtitle?: string;
}

const SectionHeader = ({ title, subtitle }: SectionHeaderProps) => {
  return (
    <div className="craSectionHeader">
      <h2>{title}</h2>
      <p>{subtitle}</p>
    </div>
  );
};

export default SectionHeader;
